import React from 'react'
import CategoryCard from './category/CategoryCard'
import CreateCategory from './category/CreateCategory'

const ManageCategory = () => {
  return (
    <div className="container mx-auto p-4">
    <h1 className="text-2xl font-bold mb-4">Manage Categories</h1>
    <CreateCategory />
    
  </div>
  )
}

export default ManageCategory